<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Account</h1>
          <p class="mt-2 text-sm text-gray-700">A list of all the Account.</p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button @click="openAccountModal(null)" type="button" class="block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
            Add Account
          </button>
        </div>
      </div>
      <SearchComponent @setSearchText="setSearchText"/>
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">

          <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
              <tr>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 sm:pl-0">ID</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Name</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Last logged in</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Last answered</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Network name</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Website prefix</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Created at</th>
                <th scope="col" class="px-3 py-1 text-right text-sm font-semibold text-gray-900">Options</th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
              <tr v-for="item in items" :key="item.id">
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.id }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.name }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.last_logged_in }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.last_answered }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.network_name }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.website_prefix }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.created_at }}</td>

                <td class="py-1 pl-3 text-sm font-medium sm:pr-0">
                  <div class="flex items-center justify-end gap-x-0">
                    <RouterLink :to="{ name: 'AccountShow', params: { id: item.id } }" class="network-button-color hover:text-gray-900">
                      <EyeIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </RouterLink>
                    <button @click="openAccountModal(item.id)" type="button" class="network-button-color hover:text-gray-900">
                      <PencilSquareIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </button>
                    <button @click="destroy(item.id)" type="button" class="network-button-color hover:text-gray-900">
                      <TrashIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <PaginationComponent :response="meta" @setPage="getItems"></PaginationComponent>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "../TwPaginationComponent.vue";
import {EyeIcon, PencilSquareIcon, TrashIcon} from "@heroicons/vue/20/solid";
import SearchComponent from "../SearchComponent.vue";
import {useModal, useModalSlot} from "vue-final-modal";
import TwModal from "../TwModal.vue";
import AccountCreateEditFormComponent from "./AccountCreateEditFormComponent.vue";

export default {
  name: "AccountIndexComponent",
  data() {
    return {
      items: [],
      meta: {},
      page: null,
      thisPage: null,
      searchText: null,
    }
  },
  components: {
    PaginationComponent,
    EyeIcon,
    PencilSquareIcon,
    TrashIcon,
    SearchComponent,
    AccountCreateEditFormComponent,
  },
  watch: {
    searchText: {
      handler(newValue, oldValue) {
        this.getItems();
      },
      deep: true
    },
  },
  methods: {
    setSearchText(value) {
      this.searchText = value;
    },
    getItems(page = null) {
      this.thisPage = page;
      axios.get(`/member-firm/accounts/index?page=${page}`, {params: {'search_text': this.searchText}}).then((res) => {
        this.items = res.data.data;
        this.meta = res.data.meta;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    destroy(id) {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/accounts/destroy/${id}`).then((res) => {
          this.$notify({ type: "success", title: "Successfully", text: res.data.message });
          this.getItems();
        }).catch((error) => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
        })
      }
    },
    openAccountModal(accountId) {
      const self = this;
      const { open, close } = useModal({
        component: TwModal,
        attrs: {
          onClose() {
            close()
          },
        },
        slots: {
          default: useModalSlot({
            component: AccountCreateEditFormComponent,
            attrs: {
              accountId: accountId,
              onReloadIndex() {
                self.getItems();
              },
              onCancel() {
                close()
              },
            },
          })
        },
      });
      open();
    },
  },
  created() {
    this.getItems();
  },
}
</script>